import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const ComingSoon = loadable(() => import(/* webpackChunkName: "ComingSoon" */ './ComingSoon'), {
  fallback: <LoadableFallback visible />,
});

const asyncComingSoon = ({ route }) => (
  <ComingSoon route={route} />
);

asyncComingSoon.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncComingSoon;
